/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventEmitter, Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface ComponentConfig {
  component: Type<any> | null;
  data?: any;
  outputEvent?: EventEmitter<any>;
}

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  // private readonly _leftContent = signal<{ component?: any; data?: any; html?: SafeHtml } | null>(null);
  // private readonly _rightContent = signal<{ component?: any; data?: any; html?: SafeHtml } | null>(null);

  // constructor(private readonly sanitizer: DomSanitizer) {}

  // get leftContent(): Signal<{ component?: any; data?: any; html?: SafeHtml } | null> {
  //   return this._leftContent;
  // }

  // get rightContent(): Signal<{ component?: any; data?: any; html?: SafeHtml } | null> {
  //   return this._rightContent;
  // }

  // setLeftContent(content: { component?: any; data?: any; html?: SafeHtml } | null): void {
  //   if (content?.html) {
  //     content.html = this.sanitizer.bypassSecurityTrustHtml(String(content.html));
  //   }
  //   this._leftContent.set(content);
  // }

  // setRightContent(content: { component?: any; data?: any; html?: SafeHtml } | null): void {
  //   if (content?.html) {
  //     content.html = this.sanitizer.bypassSecurityTrustHtml(String(content.html));
  //   }
  //   this._rightContent.set(content);
  // }

  // clearHeaderContent(): void {
  //   this._leftContent.set(null);
  //   this._rightContent.set(null);
  // }

  // private readonly _leftContent = signal<{ component?: any; data?: any } | null>(null);
  // private readonly _rightContent = signal<{ component?: any; data?: any } | null>(null);

  // get leftContent(): Signal<{ component?: any; data?: any } | null> {
  //   return this._leftContent;
  // }

  // get rightContent(): Signal<{ component?: any; data?: any } | null> {
  //   return this._rightContent;
  // }

  // setLeftContent(content: { component: any; data?: any } | null): void {
  //   this._leftContent.set(content);
  // }

  // setRightContent(content: { component: any; data?: any } | null): void {
  //   this._rightContent.set(content);
  // }

  // clearHeaderContent(): void {
  //   this._leftContent.set(null);
  //   this._rightContent.set(null);
  // }

  private readonly leftComponentSubject = new BehaviorSubject<ComponentConfig | null>(null);
  private readonly rightComponentSubject = new BehaviorSubject<ComponentConfig | null>(null);

  leftComponent$ = this.leftComponentSubject.asObservable();
  rightComponent$ = this.rightComponentSubject.asObservable();

  setLeftComponent(config: ComponentConfig): void {
    this.leftComponentSubject.next(config);
  }

  setRightComponent(config: ComponentConfig)  {
    this.rightComponentSubject.next(config);
  }

  clearHeaderContent() {
    this.leftComponentSubject.next(null);
    this.rightComponentSubject.next(null);
  }
}
